import React from 'react';
import AdminMenu from '../../../components/AdminMenu/AdminMenu';
import AttachementField from '../../../components/AttachementField/AttachementField';
import '../../../resources/adminStyle.scss';
import {evaluationService} from '../../../services/EvaluationService';
import NotificationSystem from 'react-notification-system';
import DeletePUGCertificates from '../../../components/DeleteDialog/DeleteDialog';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import AuthenticationService from '../../../services/AuthenticationService';
import DocumentOpenManager from '../../../managers/DocumentOpenManager';

const documentOpenManager = new DocumentOpenManager();

class NationalEvaluation extends React.Component{
    constructor(props){
        super(props)
        this.state={
           newInfo:{
            title:'',
            date:'',
            document:''
           },
           existingInfo:[],
           deleteInfo: {
            openedDialog: false,
            deleteId: 0
          },
          pagination: {}
        }
        this.authentication = new AuthenticationService();
    }
    handleChange=event=>{
        let newInfo = { ...this.state.newInfo };
        newInfo[event.target.name] = event.target.value;
  
          this.setState({ newInfo });
      }

    
      componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        evaluationService
        .getAll()
        .then(response => {
          this.setInfoState(response);
        })
        .catch(error => {
          console.log(error);
        });
      }
      setInfoState = response => {
        let existingInfo = this.state.existingInfo;
        existingInfo = response.national_evaluations;
        this.setState({
            existingInfo
        });
        let pagination = { ...this.state.pagination };
        pagination = response.pagination;
        this.setState({
          pagination
        });
      };
      handlePageClick = currentPage => {
        evaluationService
          .getAll(currentPage.selected + 1)
          .then(response => {
            this.setInfoState(response);
          })
          .catch(error => console.log(error));
      };
      resetForm = () => {
        let newInfo = { ...this.state.newInfo };
        newInfo = {
          title: '',
          date:'',
          document: ''
        };
        this.setState({ newInfo });
        this.setState({ disabledDocument: false });
      };
      openDeleteDialog = id => {
        let deleteInfo = { ...this.state.deleteInfo };
        deleteInfo = {
          openedDialog: true,
          deleteId: id
        };
    
        this.setState({ deleteInfo });
      };
    
      closeDeleteDialog = () => {
        let deleteInfo = { ...this.state.deleteInfo };
        deleteInfo = {
          openedDialog: false,
          deleteId: 0
        };
    
        this.setState({ deleteInfo });
      };
      handleFormSubmit = event => {
        event.preventDefault();
    
        evaluationService
          .createOrUpdate(this.state.newInfo)
          .then(response => {
    
            let existingInfo = this.state.existingInfo;
    
            let index = existingInfo.findIndex(
              existingInfo => existingInfo.id === response.id
            );
    
            if (index !== -1) {
              existingInfo[index] = response;
            } else {
              existingInfo.push(response);
            }
    
            this.setState({
              existingInfo
            });
    
            this._notificationSystem.addNotification({
              message: `Informarea a fost ${
                this.state.newInfo.id ? 'editata' : 'adaugata'
              } cu success.`,
              level: 'success',
              position: 'tc'
            });

            this.resetForm();
          })
          .catch(error => {
            this._notificationSystem.addNotification({
              message:
                'A aparut o problemă la adăugare, faceti refresh la pagina sau contactați administratorul dacă problema persistă.',
              level: 'error',
              position: 'tc'
            });
          });
      };
      onDropDocument = documents => {
        let newInfo = { ...this.state.newInfo };
        let reader = new FileReader();
        let self = this;
    
        reader.onload = function(upload) {
          newInfo.document = documents[0];
    
          self.setState({ newInfo });
          self.setState({ disabledDocument: true });
        };
        reader.readAsDataURL(documents[0]);
      };
    
      removeDocument = () => {
        let newInfo = { ...this.state.newInfo };
        newInfo.document = null;
    
        this.setState({ newInfo });
        this.setState({ disabledDocument: false });
      };
    
      setInfoForEdit = (event, info) => {
          event.preventDefault();

        let newInfo = { ...this.state.newInfo };
        newInfo = Object.assign({}, info);
        this.setState({ newInfo });
    
        if (newInfo.document && newInfo.document.url) {
          this.setState({ disabledDocument: true });
        }
      };
    
      handleDelete = () => {
        evaluationService
          .deleteEvaluation(this.state.deleteInfo.deleteId)
          .then(() => {
            let existingInfo = this.state.existingInfo.slice();
            existingInfo = existingInfo.filter(
                info => info.id !== this.state.deleteInfo.deleteId
            );
            this.setState({ existingInfo });
    
            this.closeDeleteDialog();
    
            this._notificationSystem.addNotification({
              message: 'Informarea a fost ștearsa cu success.',
              level: 'success',
              position: 'tc'
            });
          })
          .catch(error => {
            this._notificationSystem.addNotification({
              message:
                'A aparut o problema la ștergere, faceți refresh la pagină sau contactați administratorul dacă problema persistă.',
              level: 'error',
              position: 'tc'
            });
          });
      };
  
    render(){
        return(
            <div className='admin'>
                <AdminMenu/>
                <div className='admin__wrapper'>
                    <h2 className='admin__title'>Evaluare Nationala</h2>
                    <h3 className='admin__subtitle'>Adaugă un document / o informație nouă:</h3>
                        <form className='admin__form' onSubmit={this.handleFormSubmit}>
                            <h4 className='admin__label'>Titlu:</h4>
                            <input
                                className="admin__field"
                                type="text"
                                name="title"
                                onChange={this.handleChange}
                                required
                                value={this.state.newInfo.title}/>
                            <h4 className='admin__label'>Dată:</h4>
                            <input
                                className="admin__field"
                                type="date"
                                name="date"
                                required
                                onChange={this.handleChange}
                                value={this.state.newInfo.date}/>
                             <h4 className='admin__label'>Detaliere:</h4>
                            <textarea
                                rows='5'
                                cols='10'
                                className="admin__field admin__textarea"
                                type="text"
                                name="description"
                                onChange={this.handleChange}
                                value={this.state.newInfo.description}/>
                            <div className='admin__attachement'>
                                <AttachementField
                                onDrop={this.onDropDocument}
                                removeDocument={this.removeDocument}
                                document={this.state.newInfo.document}
                                documentFilename={
                                    this.state.newInfo.document_filename
                                }
                                />
                            </div>
                            <button type='submit' className='admin__submit-button'> {this.state.newInfo.id
                        ? 'Editează'
                        : 'Adaugă'}  informare:</button>       
                        </form>
                        <div className='admin__existing-documents'>
                        {this.state.existingInfo && this.state.existingInfo.length?  <h3 className='admin__no-documents'> Documente existente:</h3> : ''} 
                        {this.state.existingInfo && this.state.existingInfo.length? 
                        <div className='admin__existing-docs-wrapper'>
                         {this.state.existingInfo.map(info=>
                            ( <div className='admin__card'>
                                 <h3 className='admin__card-title'>{info.title}</h3>
                                 <div className='admin__date-box'>
                                    <img src='/images/icons/calendar.png' alt='calendar'/>
                                    <h4 className='admin__card-date'>{info.date}</h4>
                                 </div>
                                 <p className='admin__card-description'>{info.description}</p>
                                 <div className='admin__document-box'  onClick={() =>
                                    documentOpenManager.open(info.document)
                                    }>
                                     <img src='/images/icons/file.png' alt='file'/>
                                     <h3 className='admin__document-name'>Vezi document</h3>
                                 </div>
                                 <div className='admin__actions'>
                                    <h4 className='admin__edit' onClick={event => this.setInfoForEdit(event, info)} >Editează</h4>
                                    <h4 className='admin__delete'  onClick={() => this.openDeleteDialog(info.id)}>Șterge</h4>
                                 </div>
                             </div>)
                         )}
                         </div>: 
                        <h3 className='admin__no-documents'> Nu sunt documente adăugate.</h3>
                    }
                       
                               
                        </div>
                </div>
                <NotificationSystem
                    ref="notificationSystem"
                    style={NotificationSystemStyle}
                    />
                 <DeletePUGCertificates
                    opened={this.state.deleteInfo.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteți sigur că doriti să ștergeti aceasta informare?"
                    aditionalText="Dupa ștergere, informarea nu va mai putea fi recuperata."
                  />
            </div>
        )
    }
}
export default NationalEvaluation;